import React, { useState } from "react"
import PropTypes from "prop-types"
import { Button, Col, Form, Input, Label, Row } from "reactstrap"
// Toastify
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { Slide } from "react-toastify"
import API from "../../api"
import { withTranslation } from "react-i18next"
import { AvForm, AvField } from "availity-reactstrap-validation"
import DatePicker from "react-datepicker";
import getDay from "date-fns/getDay"
const AddParametrageDateMastere = props => {
  const [dateDebut, setDateDebut] = useState(new Date())
  const [dateFin, setDateFin] = useState(new Date())
  const [minAnneeInscription, setMinAnneeInscription] = useState("")
  const [malusRedoublement, setMalusRedoublement] = useState("")
  const [malusControle, setMalusControle] = useState("")
  const [malusSessionControle, setMalusSessionControle] = useState("")
  const [bonusSessionPrincipale, setBonusSessionPrincipale] = useState("")
  const [bonusSessionPassable, setBonusSessionPassable] = useState("")
  const [bonusSessionAssezBien, setBonusSessionAssezBien] = useState("")
  const [bonusSessionBien, setBonusSessionBien] = useState("")
  const [bonusSessionTresBien, setBonusSessionTresBien] = useState("")
  var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
  var annee_id = userAuthScolarite.user.annee_id
  var user_id = userAuthScolarite.user.id
  const save = async () => {
    //date debut
    let DateNote_debut = dateDebut
    let month_debut = "" + (DateNote_debut.getMonth() + 1)
    let day_debut = "" + DateNote_debut.getDate()
    let year_debut = DateNote_debut.getFullYear()
    if (month_debut.length < 2) month_debut = "0" + month_debut
    if (day_debut.length < 2) day_debut = "0" + day_debut
    var convertDate_debut = [year_debut, month_debut, day_debut].join("-")
    ///date fin
    let DateNote_fin = dateFin
    let month_fin = "" + (DateNote_fin.getMonth() + 1)
    let day_fin = "" + DateNote_fin.getDate()
    let year_fin = DateNote_fin.getFullYear()
    if (month_fin.length < 2) month_fin = "0" + month_fin
    if (day_fin.length < 2) day_fin = "0" + day_fin
    var convertDate_fin = [year_fin, month_fin, day_fin].join("-")
    if (convertDate_debut === "" && convertDate_fin ==="") {
      toast.error("⛔ Date début et date fin sont obligatoire", {
        containerId: "A",
      })
    }else if(minAnneeInscription ===""){
      toast.error("⛔ Min Année d'inscription au mastère obligatoire", {
        containerId: "A",
      })
    }else if(malusRedoublement === ""){
      toast.error("⛔ Malus redoublement obligatoire", {
        containerId: "A",
      })
    }else if(malusControle === ""){
      toast.error("⛔ Malus de Contrôle obligatoire", {
        containerId: "A",
      })
    }else if(malusSessionControle === ""){
      toast.error("⛔ Malus Session Contrôle obligatoire", {
        containerId: "A",
      })
    }else if(bonusSessionPrincipale === ""){
      toast.error("⛔ Bonus Session Principale obligatoire", {
        containerId: "A",
      })
    }else if(bonusSessionPassable === ""){
      toast.error("⛔ Bonus Session Passable obligatoire", {
        containerId: "A",
      })
    }else if(bonusSessionAssezBien === ""){
      toast.error("⛔ Bonus Session Assez Bien obligatoire", {
        containerId: "A",
      })
    }else if(bonusSessionBien === ""){
      toast.error("⛔ Bonus Session Bien obligatoire", {
        containerId: "A",
      })
    }else if(bonusSessionTresBien !== ""){
      const res = await API.post("gestion_master/parametrage/store", {
        start_date: convertDate_debut,
        end_date: convertDate_fin,
        min_annee_inscription: minAnneeInscription,
        malus_redoublement: malusRedoublement,
        malus_controle: malusControle,
        malus_session_controle: malusSessionControle,
        bonus_session_principale: bonusSessionPrincipale,
        bonus_session_passable: bonusSessionPassable,
        bonus_session_assez_bien: bonusSessionAssezBien,
        bonus_session_bien: bonusSessionBien,
        bonus_session_tres_bien: bonusSessionTresBien,
        user_id,
        annee_id
      }).then(res => {
        props.setSection(1)
      })
    } else {
      toast.error("⛔ Bonus Session Trés Bien obligatoire", {
        containerId: "A",
      })
    }
  }
  const isWeekday = date => {
    const day = getDay(date)
    return day !== 0
  }
  return (
    <React.Fragment>
      <Row>
        <AvForm>
          <Form>
            <Row style={{display: "flex", justifyContent: "center"}}>
              <Col lg="4">
                <div className="mb-3">
                  <Label for="basicpill-lastname-input2">Date Début :</Label>
                  <DatePicker
                    selected={dateDebut}
                    filterDate={isWeekday}
                    className="form-control ddate"
                    dateFormat="dd/MM/yyyy"
                    onChange={e => setDateDebut(e)}
                  />
                </div>
              </Col>
              <Col lg="4">
                <div className="mb-3">
                  <Label for="basicpill-lastname-input2">Date Fin :</Label>
                  <DatePicker
                    selected={dateFin}
                    filterDate={isWeekday}
                    className="form-control ddate"
                    dateFormat="dd/MM/yyyy"
                    onChange={e => setDateFin(e)}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg="4">
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">
                    {"Min Année d'inscription au mastère"}
                  </Label>
                  <Input
                    lg="3"
                    type="number"
                    className="form-control"
                    placeholder="Min Année d'inscription au mastère"
                    required={true}
                    onChange={e => setMinAnneeInscription(e.target.value)}
                  />
                </div>
              </Col>
              <Col lg="4">
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">
                    Malus redoublement :
                  </Label>
                  <Input
                    lg="3"
                    type="number"
                    className="form-control"
                    placeholder=" Malus redoublement"
                    required={true}
                    onChange={e => setMalusRedoublement(e.target.value)}
                  />
                </div>
              </Col>
              <Col lg="4">
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">
                    Malus de Contrôle :
                  </Label>
                  <Input
                    lg="3"
                    type="number"
                    className="form-control"
                    placeholder="Malus de Contrôle"
                    onChange={e => setMalusControle(e.target.value)}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg="6">
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">
                    Malus Session Contrôle :
                  </Label>
                  <Input
                    lg="3"
                    type="number"
                    className="form-control"
                    placeholder="Malus Session Controle"
                    onChange={e => setMalusSessionControle(e.target.value)}
                  />
                </div>
              </Col>
              <Col lg="6">
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">
                    Bonus Session Principale :
                  </Label>
                  <Input
                    lg="3"
                    type="number"
                    className="form-control"
                    placeholder="Bonus Session Principale"
                    onChange={e => setBonusSessionPrincipale(e.target.value)}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg="6">
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">
                    Bonus Session Passable :
                  </Label>
                  <Input
                    lg="3"
                    type="number"
                    className="form-control"
                    placeholder="Bonus Session Passable"
                    onChange={e => setBonusSessionPassable(e.target.value)}
                  />
                </div>
              </Col>
              <Col lg="6">
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">
                    Bonus Session Assez Bien :
                  </Label>
                  <Input
                    lg="3"
                    type="number"
                    className="form-control"
                    placeholder="Bonus Session Assez Bien"
                    onChange={e => setBonusSessionAssezBien(e.target.value)}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg="6">
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">
                    Bonus Session Bien :
                  </Label>
                  <Input
                    lg="3"
                    type="number"
                    className="form-control"
                    placeholder="Bonus Session Bien"
                    onChange={e => setBonusSessionBien(e.target.value)}
                  />
                </div>
              </Col>
              <Col lg="6">
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">
                    Bonus Session Trés Bien :
                  </Label>
                  <Input
                    lg="3"
                    type="number"
                    className="form-control"
                    placeholder="Bonus Session Trés Bien"
                    onChange={e => setBonusSessionTresBien(e.target.value)}
                  />
                </div>
              </Col>
            </Row>
          </Form>
          <div style={{ display: "flex", justifyContent: "center" }}>
            {" "}
            <Col lg="6">
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                }}
                className="text-center mt-4"
              >
                <Button
                  type="button"
                  color="warning"
                  className="btn btn-warning  mb-2 me-2"
                  onClick={props.back}
                >
                  {props.t("Annuler")}
                </Button>
              </div>
            </Col>
            <Col lg="6">
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                }}
                className="text-center mt-4"
              >
                <button
                  type="button"
                  className="btn btn-primary "
                  onClick={save}
                >
                  {props.t("Confirmer")}
                </button>
              </div>
            </Col>
          </div>
        </AvForm>
      </Row>
      <ToastContainer
        transition={Slide}
        enableMultiContainer
        containerId={"A"}
        position={toast.POSITION.TOP_RIGHT}
        autoClose={2500}
      />
    </React.Fragment>
  )
}

export default withTranslation()(AddParametrageDateMastere)
AddParametrageDateMastere.propTypes = {
  history: PropTypes.object,
  back: PropTypes.object,
  setSection: PropTypes.object,
  t: PropTypes.any,
}
